export default {
  products: {},
  productsLoaded: false,
  quickOpenBatch: {
    id: null,
    product_id: null,
  },
};
